import React from 'react';

const PainfulPaint = () => {
  return (
    <div style={{ width: '100%', overflowX: 'hidden', marginBottom: '50px', color: '#F3E5AB', fontFamily: 'Milonga, serif' }}>
      
      {/* Title */}
      <h1 style={{ fontSize: '48px', textAlign: 'center', marginBottom: '20px' }}>Painful Paint</h1>

      {/* Iframe Section */}
      <div style={{ width: '100%', height: '75vh' }}>
        <iframe
          src="/games/PainfulPaint/painfulpaint.html"
          title="Escape The Maze"
          width="100%"
          height="120%"
          style={{ border: 'none' }}
        />
      </div>

      {/* Text Content */}
      <div style={{ textAlign: 'center', padding: '40px 20px 0' }}>
        <h2 style={{ fontSize: '36px', marginBottom: '20px' }}>How to Play</h2>
        <p style={{ fontSize: '18px', maxWidth: '800px', margin: '0 auto' }}>
          This program is a paint program. You can choose between different types of shapes, colors, and whether or not you wish for them to be filled. To begin drawing shapes left click on the canvas. For the Box, Line, Triangle, and N Polygon, you will need to draw each point. In order to stop drawing in the N Polygon, right click. For the circle, the first point you click will be its center, and the second will be its edge.
        </p>

        <h2 style={{ fontSize: '36px', margin: '40px 0 20px' }}>About the Game</h2>
        <p style={{ fontSize: '18px', maxWidth: '800px', margin: '0 auto' }}>
          Painful Paint was one of the first WebGL projects created for my Computer Graphics class. It involved combining many different elements to create a custom system for drawing a multitude of different shapes. I also had to create non-WebGL elements that would interact with my WebGL code such as selecting the type of shape, selecting the color, and even using the different drawing styles to fill or keep hollow.
        </p>
      </div>
    </div>
  );
};

export default PainfulPaint;